module.exports = __webpack_public_path__ + "img/step28_a_stand_power_stacker_pocket_fits.82bd497d.png";